import { render, staticRenderFns } from "./DiscountRecord.vue?vue&type=template&id=062d7a40&scoped=true&"
import script from "./DiscountRecord.vue?vue&type=script&lang=ts&"
export * from "./DiscountRecord.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountRecord.vue?vue&type=style&index=0&id=062d7a40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062d7a40",
  null
  
)

export default component.exports